import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from '@/app/App';
import { Providers } from '@/app/providers';
import { initPwaService } from '@/services/pwa/pwaService';
import '@/index.css';

// Initialize PWA service worker with user-controlled prompt strategy
initPwaService();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Providers>
      <App />
    </Providers>
  </React.StrictMode>
);
